/* eslint-disable max-len */
import cn from 'classnames';
import styles from './AboutPage.module.scss';

import { PagePagination } from '../../../components/PagePagination/PagePagination';
import { PageLayout } from '../../../components/PageLayout/PageLayout';
import { PageHeader } from '../../../components/PageHeader/PageHeader';

import { Tag } from '../../../components/Tag/Tag';

import goalImageSrc from '../../../assets/images/Goal.png';
import studentImageSrc from '../../../assets/images/AboutStudent.png';
import employerImageSrc from '../../../assets/images/AboutEmployer.png';


export const AboutPage = () => {
    return (
        <PageLayout>
            <div className={styles.about}>
                <div className={styles.about__wrapper}>
                    <PagePagination linkName={'О нас'} />
                    <PageHeader
                        title={'О нас'}
                        description={
                            'Центр карьеры Юридического факультета МГУ успешно работает с 2009 года. Мы создаем пространство для встречи студентов, выпускников и ведущих работодателей, помогаем с профессиональным самоопределением и открываем пути к построению успешной карьеры в юриспруденции.'
                        }
                        className={styles.AboutHeader}
                    />
                    <Goals />
                    <Banners />
                    <Offers />
                </div>
            </div>
        </PageLayout>
    );
};

export enum GoalSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
}

interface AboutPointProps {
    goal_size: GoalSize;
    id: number;
    header: string;
    description?: string[] | React.ReactNode;
}

export const AboutPoint = ({ goal_size, id, header, description }: AboutPointProps) => {
    return (
        <div className={`${styles.goal} ${styles[`goal__${goal_size}`]}`}>
            <div className={styles.goal__top}>
                <div className={styles.goal__number}>
                    <span className={styles.goal__number_text}>{id}</span>
                </div>
                <h3 className={`${styles.goal__header} ${styles[`goal__header__${goal_size}`]}`}>{header}</h3>
            </div>
            <div className={styles.goal__description}>{description}</div>
        </div>
    );
};


const Goals = () => {
    return (
        <div className={styles.goals}>
            <div className={styles.goals__wrapper}>
                <h3 className={styles.goals__header}>Наши цели:</h3>
                <div className={styles.goals__content}>
                    <div className={styles.goals__container}>
                        <AboutPoint 
                            goal_size={GoalSize.Medium}
                            id={1}
                            header={'Поддержка на всех этапах'}
                            description={'Содействуем студентам и выпускникам Юридического факультета МГУ в трудоустройстве и построении успешной карьеры в юриспруденции.'}
                        />
                        <AboutPoint 
                            goal_size={GoalSize.Medium}
                            id={2}
                            header={'Карьерная навигация'}
                            description={'Помогаем в профессиональном самоопределении и планировании карьерного пути.'}
                        />
                        <AboutPoint 
                            goal_size={GoalSize.Medium}
                            id={3}
                            header={'Создание профессиональных связей'}
                            description={'Мы объединяем талантливых студентов и выпускников с ведущими российскими работодателями.'}
                        />
                    </div>
                    <div className={styles.goals__photo}>
                        <img
                            className={styles.goals__image}
                            src={goalImageSrc}
                            alt={'Career center goals'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export const Banners = () => {
    return (
        <div className={styles.banners}>
            <div className={styles.banners__container}>
                <AboutBanner
                    type="employers"
                    label="Для работодателей"
                    image={employerImageSrc}
                    header={'Центр карьеры Юридического факультета МГУ предлагает работодателям комплекс решений для поиска и привлечения лучших кандидатов\u00A0- студентов и выпускников'}
                    description={
                        <>
                        <p>Мы готовы стать вашим надежным партнёром в следующих форматах:</p>

                        <ol>
                            <li>
                            <strong>Размещение вакансий и информирование аудитории</strong>
                                <ul>
                                    <li>
                                    Публикация ваших вакансий на официальном сайте факультета, портале
                                    Центра карьеры и информационных стендах факультета. Полное
                                    информационное сопровождение ваших мероприятий на нашей площадке.
                                    </li>
                                </ul>
                            </li>

                            <li>
                            <strong>Прямой диалог с будущими юристами</strong>
                                <ul>
                                    <li>
                                    Организация презентаций вашей компании для целевой аудитории.
                                    </li>
                                    <li>
                                    Участие в наших событиях: «Неделях карьеры», ярмарках вакансий и
                                    тематических конференциях.
                                    </li>
                                </ul>
                            </li>

                            <li>
                            <strong>Образовательное партнёрство и ранний поиск талантов</strong>
                                <ul>
                                    <li>
                                    Проведение совместных мероприятий: семинаров, лекций, круглых столов
                                    или кейс-чемпионатов. Мы поможем с предварительным отбором студентов
                                    по вашим критериям.
                                    </li>
                                </ul>
                            </li>

                            <li>
                            <strong>HR-аутсорсинг</strong>
                                <ul>
                                    <li>
                                    Экспертный подбор и первичная оценка кандидатов: анализ резюме, сбор
                                    рекомендаций, проведение первых собеседований и разработка
                                    индивидуальной программы отбора.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                        </>
                    }
                />
            </div>
            <div className={styles.banners__container}>
                <AboutBanner
                    type="students"
                    label="Для студентов"
                    image={studentImageSrc}
                    header={'Центр карьеры Юрфака МГУ\u00A0- ваш персональный ресурс для старта и развития в профессии'}
                    description={
                        <>
                        <p>
                            Мы помогаем вам построить успешную юридическую карьеру, предоставляя целый спектр возможностей:
                        </p>

                        <ol>
                            <li>
                                <strong>Карьерное консультирование и развитие</strong>
                                <ul>
                                    <li>
                                        <strong>Профориентация:</strong> Поможем определить ваши сильные стороны и выбрать
                                        оптимальное направление для карьерного старта.
                                    </li>
                                    <li>
                                        <strong>Подготовка к отбору:</strong> Индивидуальные консультации по составлению
                                        убедительного резюме и подготовке к собеседованию в ведущие компании.
                                    </li>
                                    <li>
                                        <strong>Личностный рост:</strong> Тренинги и советы по развитию ключевых профессиональных
                                        качеств успешного юриста.
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <strong>Прямой доступ к вакансиям и стажировкам</strong>
                                <ul>
                                    <li>
                                        <strong>Эксклюзивная база вакансий:</strong> Мы собираем для вас предложения о работе и
                                        стажировках (включая стартовые позиции) от ведущих юрфирм, компаний-партнеров и выпускников
                                        факультета.
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <strong>Нетворкинг и прямое общение с работодателями</strong>
                                <ul>
                                    <li>
                                        <strong>Презентации и стендовые сессии:</strong> Участвуйте в мероприятиях с прямыми
                                        работодателями, чтобы задать вопросы и завести полезные контакты.
                                    </li>
                                    <li>
                                        <strong>Встречи с экспертами:</strong> Получайте уникальный опыт из первых рук на личных
                                        встречах с руководителями HR-департаментов и топ-юристами.
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <strong>Практические навыки через образование</strong>
                                <ul>
                                    <li>
                                        <strong>Мастер-классы и воркшопы:</strong> Применяйте знания на практике через бизнес-кейсы,
                                        деловые игры и семинары от практикующих экспертов.
                                    </li>
                                </ul>
                            </li>
                        </ol>

                        <p>
                            Мы всегда на связи: актуальная информация на нашем сайте и персональная поддержка в Центре карьеры.
                        </p>
                        </>
                    }
                />
            </div>
        </div>
    );
};

interface AboutBannerProps {
    type: 'employers' | 'students';
    label: string;
    image: string;
    header: string;
    description?: string[] | React.ReactNode;
}

const AboutBanner = ({ type, label, image, header, description }: AboutBannerProps) => {
    return (
        <div className={cn(styles.banner, styles[`banner__${type}`])}>
            <Tag type="rubric" content={label} />
            <h4 className={styles.banner__header}>{header}</h4>

            <div className={styles.banner__description}>{description}</div>

            <img className={styles.banner__image} src={image} alt="" />
        </div>
    );
};

const Offers = () => {
    return (
        <div className={styles.offers}>
            <h1 className={styles.offers__header}>
                Выпускникам Юридического факультета МГУ Центр карьеры предлагает партнерство для взаимного роста.<br />
                Мы ценим ваш опыт и готовы помочь в развитии вашей карьеры, а также предоставить платформу для обмена опытом.
            </h1>
            <div className={styles.offers__wrapper}>
                <AboutPoint 
                    goal_size={GoalSize.Large}
                    id={1}
                    header={'Доступ к эксклюзивным вакансиям'}
                    description={
                        <ul>
                            <li>
                                Подбор вакансий и стажировок на средние и топовые позиции в ведущих российских и международных компаниях, соответствующих вашему опыту и амбициям.
                            </li>
                        </ul>
                    }
                />
                <AboutPoint 
                    goal_size={GoalSize.Large}
                    id={2}
                    header={'Платформа для нетворкинга'}
                    description={
                        <ul>
                            <li>
                                <strong>Участие в мероприятиях:</strong> Присоединяйтесь к встречам выпускников Юрфака МГУ для расширения профессионального круга общения.
                            </li>
                            <li>
                                <strong>Презентация вашей компании:</strong> Проведите презентацию или карьерный мастер-класс для талантливых студентов и выпускников&nbsp;- будущих коллег.
                            </li>
                            <li>
                                <strong>Обмен опытом:</strong> Станьте спикером на наших образовательных мероприятиях (семинарах, круглых столах, конференциях) и поделитесь практическими знаниями.
                            </li>
                        </ul>
                    }
                />
                <AboutPoint 
                    goal_size={GoalSize.Large}
                    id={3}
                    header={'Возвращение в alma mater'}
                    description={
                        <ul>
                            <li>
                                <strong>Вклад в сообщество:</strong> Помогите сформировать новое поколение юристов, получите доступ к самым мотивированным студентам и укрепите связь с факультетом.
                            </li>
                        </ul>
                    }
                />
            </div>
            <p className={styles.offers__footer}>
                Станьте частью сообщества лидеров юридической профессии вместе с Центром карьеры!
            </p>
        </div>
    );
};
